module.exports = __webpack_public_path__ + "328878dc17d8a3b2f9b72961ce079c3a.jpg";